import React, { useEffect, useRef } from 'react';
import { useAppSelector } from '../../redux/hook';
import {
	initializeMap,
	initializeMapWithAddress,
	updateMap,
	updateMapDirection,
} from './MapClient.services';
import {
	DRIVER,
	ORDER_FLOW_TYPE,
	ORDER_PHASE,
	ORDER_PHASE_CONTACTING,
	SHOP,
} from '../../constants';

type MapClientProps = {
	chargeId: string;
};

export default function MapClient({ chargeId }: MapClientProps) {
	const mapCanvasRef = useRef<HTMLDivElement>(null);
	const refsRef = useRef({
		map: null as any,
		mapCanvas: null as HTMLDivElement | null,
		directionsService: null as any,
		directionsDisplay: null as any,
		orderMarker: null as any,
		customerMarker: null as any,
		circle1: null as any,
		circle2: null as any,
		orderLocation: null as any,
	});

	const { drivers, shops, orders } = useAppSelector((state) => ({
		drivers: state.driverReducer.drivers,
		shops: state.shopReducer.shops,
		orders: state.orderReducer.orders,
	}));

	useEffect(() => {
		const order = orders[chargeId];
		if (!order) return;

		const { shopId, address, status, orderFlowType } = order;
		const { location } = address;
		const shop = shops[shopId];
		const shopAddress = shop?.address;
		if (!shopAddress) return;

		refsRef.current.mapCanvas = mapCanvasRef.current;

		if (
			orderFlowType === ORDER_FLOW_TYPE.REVERSE &&
			status === ORDER_PHASE_CONTACTING
		) {
			const addressForMap = address?.location ?? address;
			initializeMapWithAddress(addressForMap, refsRef.current);
			updateMap(location, refsRef.current);
		} else {
			const driverLocation =
				(drivers[chargeId] && drivers[chargeId].driverLocation) || null;
			initializeMap(refsRef.current);
			if (!driverLocation) {
				updateMapDirection(
					shopAddress.location,
					location,
					SHOP,
					refsRef.current
				);
			} else {
				updateMapDirection(
					driverLocation,
					location,
					DRIVER,
					refsRef.current
				);
			}
		}
	}, [chargeId, orders, drivers, shops]);

	useEffect(() => {
		const order = orders[chargeId];
		if (!order) return;

		const { shopId, address, status } = order;
		const { location } = address;
		const shop = shops[shopId];
		const shopAddress = shop?.address;
		if (!shopAddress) return;

		if (status === ORDER_PHASE.DELIVERING) {
			const driverLocation =
				(drivers[chargeId] && drivers[chargeId].driverLocation) || null;
			if (!driverLocation) {
				updateMapDirection(
					shopAddress.location,
					location,
					SHOP,
					refsRef.current
				);
			} else {
				updateMapDirection(
					driverLocation,
					location,
					DRIVER,
					refsRef.current
				);
			}
		}
	}, [chargeId, orders, drivers, shops]);

	return <div ref={mapCanvasRef} style={{ height: '35vh' }} />;
}
